<template>
  <div class="grow w-full overflow-hidden relative">

    <div v-if='!loaded && !error' class="flex flex-row h-full w-full">
      <div class="mx-4 w-full self-center">
        <div class="text-gray-600 text-xs tracking-tight text-center">Awesome Incoming...</div>
        <div class="shadow bg-gray-700 self-center mx-4">
          <div class="bg-orange-500 text-xs leading-none py-1 text-center text-white" :style="{width:'0%'}">&nbsp;</div>
        </div>
      </div>
    </div>

    <pbc-prompt-video v-if='promptVideo.thumbnail' :video='promptVideo' class="flex flex-row h-full w-full" @click='onClickPromptVideo' />
    <pbc-error class="my-auto" v-if='!!error' :error='error' :retry='true' @retry='onRetry' :pin='false' message='Could not load post.' />

    <pbc-play v-if="!promptVideo.thumbnail && startPixi && loaded"
              :id="id"
              :gamedata='gamedata'
              :ignore-global-pause='ignoreGlobalPause'
              :thumbnail='thumbnail'
              @prompt-video='onPromptVideo'
              class='relative'
              @started='onStarted'
              @visible='onVisible'
              @state='onGameState'
              @view-post='$emit("view-post")'/>

    <div v-if='showThumbnail' class="absolute left-0 right-0 bottom-0 top-0" :style='previewStyle'>
      <div class="flex flex-col items-center justify-center h-full">

        <play-circle-outline v-if='!visible' :size='96' class="text-white" />
        <span v-else class='spinner spinner-thick spinner-white text-6xl my-auto mx-auto font-bold text-white'>
        </span>

      </div>
    </div>


  </div>
</template>
<script>
import PlayCircleOutline from '@icons/PlayCircleOutline.vue';
import UAParser from 'ua-parser-js';
const uaparser = new UAParser();

import PbcPromptVideo from '@ui/molecules/PbcPromptVideo.vue';
import PbcPlay from '@ui/molecules/PbcPlay.vue';
import Gamedata from '@edit/tree/gamedata.js';
export default {
  inject:['api'],
  props:{
    id:{
      type:String,
      required:true
    },
    game:{
      type:String,
      required:true
    },
    startPixi:{
      type: Boolean,
      default: false
    },
    fetch:{
      type:Boolean,
      default:false
    },
    ignoreGlobalPause:{
      type:Boolean,
      default:false
    },
    thumbnail:{
      type:String,
      default:''
    }
  },
  data() {
    return {
      gamedata:{},
      loaded:false,
      error:'',
      promptVideo: {},
      showThumbnail: true,
      visible:false,
      gameLoaded:false
    }
  },
  mounted() {
  },
  methods:{
    onGameState(state) {
      if (state === 'loaded') {
        this.gameLoaded = true;
      }
    },
    onVisible(visible) {
      this.visible = visible;
    },
    onStarted(started) {
      this.showThumbnail = !started;
      if (!started) {
        this.visible = false;
      }
    },
    checkForVideos() {
      const videoComponents = this.gamedata.gamedata.scenes[0].components.filter( ({type}) => {
        return type === 'video';
      });
      if (videoComponents.length) {
        this.promptVideo = videoComponents[0];
      }
    },
    onClickPromptVideo() {
      this.promptVideo = {};
    },
    onPromptVideo(data) {
      this.promptVideo = data;
    },
    async getGameData(id) {
      let signal;
      if (typeof(window.AbortController) !== 'undefined') {
        this.abortController = new AbortController();
        signal = this.abortController.signal;
      }
      const response = await fetch(this.api.makeGameUrl(id), {
        signal
      });
      if (response.status !== 200) {
        throw new Error('cannot load post: ' + (response||{}).status)
      }
      const data = await response.json();
      return data;
    },

    async load() {
      if (this.abortController) {
        return;
      }
      if (process.browser && !this.abortController) {
        try {
          const gamedata = await this.getGameData(this.game);
          this.gamedata = new Gamedata(gamedata);
          this.loaded = true;
          const isSafari = uaparser.getBrowser().name.toLowerCase().includes('safari');
          if (isSafari) {
            this.checkForVideos();
          }
          this.error = '';
        } catch (e) {
          if (this.fetch) {
            this.error = JSON.stringify(e.message);
            throw e;
          }
          this.loaded = false;
        }
      } else {
        this.loaded = false;
      }
    },
    async onRetry() {
      this.loaded = false;
      this.error = '';
      this.abortController = null;
      await this.load();
    }
  },
  components:{
    PbcPlay,
    PbcPromptVideo,
    PlayCircleOutline
  },
  watch:{
    fetch:{
      handler(nv) {
        if (nv && !this.loaded) {
          this.load();
        }
        if (!nv) {
          if (this.abortController) {
            this.abortController.abort();
            this.abortController = null;
          }
          this.loaded = false;
        }
      },
      immediate:true
    }
  },
  computed:{
    previewUrl() {
      if (this.thumbnail && this.thumbnail !== '' && this.thumbnail !== 'placeholder.png') {
        return this.api.makeThumbnailUrl(this.thumbnail);
      } else {
        return '';
      }
    },
    previewStyle() {
      if (this.previewUrl !== '') {
        return {
          'background-image':`url(${this.previewUrl})`,
          'background-repeat':'no-repeat',
          'background-size':'cover',
          'background-position':'center center'
        }
      } else {
        return {
        }
      }
    },
  }

}
</script>
